import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectStepMedicalExpenses, makeSelectStepMedicalExpensesErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
  resetFormEuropeanUnionData,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { PrescriptionMedicinesForInjury } from './components/PrescriptionMedicinesForInjury';
import { PrescriptionMedicinesNotInjury } from './components/PrescriptionMedicinesNotInjury';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import CurrencySelector from '../components/CurrencySelector';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { stepMedicalExpensesExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';

export class StepMedicalExpenses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onPrescriptionMedicinesNotInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesNotInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPrescriptionMedicinesForInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesForInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  // handleReasonsForTripInterruption = (propertyName) => (event) => {
  //   const { reasonsForTripInterruption } = this.props.form;
  //   const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
  //   ? reasonsForTripInterruption.toJS()
  //   : reasonsForTripInterruption || [];
  //   const listChecked = _.cloneDeep(reasons);
  //   const target = event.target;
  //   const name = target.name;
  //   const value = target.type === 'checkbox' ? target.checked : target.value;
  //   if (value) {
  //     listChecked.push(name);
  //   } else {
  //     listChecked.splice(listChecked.indexOf(name), 1);
  //   }
  //   this.props.onFormDataChange(propertyName, listChecked);
  // };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  // handleReasonsForDelay = (propertyName) => (event) => {
  //   const { reasonsForDelay } = this.props.form;
  //   const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
  //   ? reasonsForDelay.toJS()
  //   : reasonsForDelay || [];
  //   const listChecked = _.cloneDeep(reasons);
  //   const target = event.target;
  //   const name = target.name;
  //   const value = target.type === 'checkbox' ? target.checked : target.value;
  //   if (value) {
  //     listChecked.push(name);
  //   } else {
  //     listChecked.splice(listChecked.indexOf(name), 1);
  //   }
  //   this.props.onFormDataChange(propertyName, listChecked);
  // };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }


  renderPrescriptionMedicinesForInjury() {
    const { prescriptionMedicinesForInjury } = this.props.form;
    const newPrescriptionMedicinesForInjury = this.appendIds(prescriptionMedicinesForInjury);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <PrescriptionMedicinesForInjury
          data={newPrescriptionMedicinesForInjury}
          onChange={this.onPrescriptionMedicinesForInjuryChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }


  renderPrescriptionMedicinesNotInjury() {
    const { prescriptionMedicinesNotInjury } = this.props.form;
    const newPrescriptionMedicinesNotInjury = this.appendIds(prescriptionMedicinesNotInjury);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <PrescriptionMedicinesNotInjury
          data={newPrescriptionMedicinesNotInjury}
          onChange={this.onPrescriptionMedicinesNotInjuryChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderHospitalAndMedicalExpenses() {
    const {
      accidentStartDate,
      nameOfPhysicianFacilityFirstContacted,
      addressForHospital,
      cityOrTownForHospital,
      accidentFirstTreatment,
      countryForHospital,
      postalCodeForHospital,
      emailForHospital,
      phoneNumberForHospital,
      isTheClaimTheResultOfAniLLness,
      accidentStartDateForIllness,
      symptoms,
      detailsForIllness,
      isTheClaimTheResultOfAccidentOrInjury,
      place,
      accidentDate,
      accidentTime,
      detailsForAccident,
      wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity,
      ifOtherPleaseDescribeForHospital,
      nameOfPhysicianFacilityFirstContactedForPhysician,
      addressForPhysician,
      cityOrTownForPhysician,
      countryForPhysician,
      postalCodeForPhysician,
      phoneNumberForPhysician,
      facilityName,
      addressForProvide,
      cityOrTownForProvide,
      countryForProvide,
      postalCodeForProvide,
      phoneNumberForProvide,
      admitDate,
      dischargeDate,
      timeOfAdmission,
      timeOfDischarge,
      expensesClaimed,
      currencyForProvide,
      didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness,
      wereYouTravelingToReceiveMedicalTreatment,
      alternativeTreatment,
      ifYesWhenDidYouLearnOfTheAlternativeTreatment,
      whoRecommendedTheTreatment,
      areYouPregnant,
      ifYesNumberOfWeeks,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeOfAdmission = timeOfAdmission ? moment(timeOfAdmission) : null;
    const newTimeOfDischarge = timeOfDischarge ? moment(timeOfDischarge) : null;
    const newAccidentTime = accidentTime ? moment(accidentTime) : null;
    const { isSummary, submitted, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.hospitalAndMedicalExpenses} />
            </PageSectionHeader>           
          </div>
        </div>
        <div className={'row'}>
            <div className={'col-sm-4 form-group'}>
                <Validate
                  name="accidentStartDate"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={accidentStartDate}
                  fieldName={messages.accidentStartDate}
                  >
                  <DatePicker
                    disabled={isReadOnly}
                    type="text"
                    onDayChange={this.handleDayChange('form.accidentStartDate')}
                    value={accidentStartDate}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentStartDate' }) }}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentStartDate' }) }}
                  />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="accidentFirstTreatment"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={accidentFirstTreatment}
                  fieldName={messages.accidentFirstTreatment}
                  >
                  <DatePicker
                    disabled={isReadOnly}
                    type="text"
                    onDayChange={this.handleDayChange('form.accidentFirstTreatment')}
                    value={accidentFirstTreatment}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentFirstTreatment' }) }}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentFirstTreatment' }) }}
                  />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}></div>
        </div>
        <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="expensesClaimed"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={expensesClaimed}
                  fieldName={messages.expensesClaimed}                  
                  >
                    <Textbox
                      name="expensesClaimed"
                      type="text"
                      onChange={this.handleChangeAmount('form.expensesClaimed')}
                      value={expensesClaimed}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.expensesClaimed' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-4 form-group'}>
                  <Validate
                    name="currencyForProvide"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={currencyForProvide}
                    fieldName={messages.currency}
                  >
                    <CurrencySelector
                      onChange={this.handleCurrencyChange('form.currencyForProvide')}
                      disabled={isReadOnly}
                      value={currencyForProvide}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.currency' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
                  </div>
                  <div className={'col-sm-4 form-group'}></div>
        </div>
        <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
                <Validate
                  name="nameOfPhysicianFacilityFirstContacted"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={nameOfPhysicianFacilityFirstContacted}
                  fieldName={messages.nameOfPhysicianFacilityFirstContacted}                  
                  >
                    <Textbox
                      name="nameOfPhysicianFacilityFirstContacted"
                      type="text"
                      onChange={this.handleChange('form.nameOfPhysicianFacilityFirstContacted')}
                      value={nameOfPhysicianFacilityFirstContacted}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.nameOfPhysicianFacilityFirstContacted' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
        </div>
        <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressForHospital}
                  fieldName={messages.address}                  
                  >
                    <Textbox
                      name="addressForHospital"
                      type="text"
                      onChange={this.handleChange('form.addressForHospital')}
                      value={addressForHospital}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.address' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityOrTownForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityOrTownForHospital}
                  fieldName={messages.cityOrTown}                  
                  >
                    <Textbox
                      name="cityOrTownForHospital"
                      type="text"
                      onChange={this.handleChange('form.cityOrTownForHospital')}
                      value={cityOrTownForHospital}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.cityOrTown' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalCodeForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalCodeForHospital}
                  fieldName={messages.postalCode}                  
                  >
                    <Textbox
                      name="postalCodeForHospital"
                      type="text"
                      onChange={this.handleChange('form.postalCodeForHospital')}
                      value={postalCodeForHospital}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.postalCode' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="countryForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={countryForHospital}
                  fieldName={messages.country}                  
                  >
                    <Textbox
                      name="countryForHospital"
                      type="text"
                      onChange={this.handleChange('form.countryForHospital')}
                      value={countryForHospital}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.country' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'row'}>
            <div className={'col-sm-4 form-group'}>
              <Validate
                  name="emailForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={emailForHospital}
                  fieldName={messages.email}                  
                  >
                    <Textbox
                      name="emailForHospital"
                      type="text"
                      onChange={this.handleChange('form.emailForHospital')}
                      value={emailForHospital}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.email' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
            <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberForHospital}
                  fieldName={messages.phoneNumber}                  
                  >
                    <Textbox
                      name="phoneNumberForHospital"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberForHospital')}
                      value={phoneNumberForHospital}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.phoneNumber' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
            <div className={'col-sm-4 form-group'}>
            </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.isTheClaimTheResultOfAniLLness} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={isTheClaimTheResultOfAniLLness === 'true'}
                    onChange={this.handleChange('form.isTheClaimTheResultOfAniLLness')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={isTheClaimTheResultOfAniLLness === 'false'}
                    onChange={this.handleChange('form.isTheClaimTheResultOfAniLLness')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {isTheClaimTheResultOfAniLLness === 'true' &&
        <div>
          <div className={'ml-2 row'}>
            <div className={'col-sm-4 form-group'}>
                <Validate
                  name="accidentStartDateForIllness"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={accidentStartDateForIllness}
                  fieldName={messages.accidentStartDateForIllness}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="accidentStartDateForIllness"
                    type="text"
                    onDayChange={this.handleDayChange('form.accidentStartDateForIllness')}
                    value={accidentStartDateForIllness}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentStartDateForIllness' }) }}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentStartDateForIllness' }) }}
                    />
                  </ErrorMessage>
                </Validate>
            </div>
            <div className={'col-sm-8 form-group'}>
                <Validate
                  name="symptoms"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={symptoms}
                  fieldName={messages.symptoms}                  
                  >
                    <Textbox
                      name="symptoms"
                      type="text"
                      onChange={this.handleChange('form.symptoms')}
                      value={symptoms}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.symptoms' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
          </div>
          <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsForIllness"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsForIllness}
                  fieldName={messages.details}                  
                  >
                    <Textbox
                      name="detailsForIllness"
                      type="text"
                      onChange={this.handleChange('form.detailsForIllness')}
                      value={detailsForIllness}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.details' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
          </div>
        </div>
        }
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.isTheClaimTheResultOfAccidentOrInjury} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={isTheClaimTheResultOfAccidentOrInjury === 'true'}
                    onChange={this.handleChange('form.isTheClaimTheResultOfAccidentOrInjury')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={isTheClaimTheResultOfAccidentOrInjury === 'false'}
                    onChange={this.handleChange('form.isTheClaimTheResultOfAccidentOrInjury')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {isTheClaimTheResultOfAccidentOrInjury === 'true' &&
        <div>
          <div className={'ml-2 row'}>
            <div className={'col-sm-4 form-group'}>
                <Validate
                  name="place"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={place}
                  fieldName={messages.place}                  
                  >
                    <Textbox
                      name="place"
                      type="text"
                      onChange={this.handleChange('form.place')}
                      value={place}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.place' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
            </div>
            <div className={'col-sm-4 form-group'}>
                <Validate
                  name="accidentDate"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={accidentDate}
                  fieldName={messages.accidentDate}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="accidentDate"
                    type="text"
                    onDayChange={this.handleDayChange('form.accidentDate')}
                    value={accidentDate}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentDate' }) }}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentDate' }) }}
                    />
                  </ErrorMessage>
                </Validate>
            </div>
            <div className={'col-sm-4 form-group'}>
                <Validate
                  name="accidentTime"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={newAccidentTime}
                  fieldName={messages.accidentTime}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.accidentTime')}
                    value={newAccidentTime}
                    placeholder="hh:mm"
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentTime' }) }}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentTime' }) }}
                    />
                  </ErrorMessage>
                </Validate>
            </div>
          </div>
          <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsForAccident"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsForAccident}
                  fieldName={messages.details}                  
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="detailsForAccident"
                      type="text"
                      onChange={this.handleChange('form.detailsForAccident')}
                      value={detailsForAccident}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.details' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
          </div>
        </div>
        }
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity === 'true'}
                    onChange={this.handleChange('form.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity === 'false'}
                    onChange={this.handleChange('form.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity === 'true' &&
          <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="ifOtherPleaseDescribeForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={ifOtherPleaseDescribeForHospital}
                  fieldName={messages.otherDescription}                  
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="ifOtherPleaseDescribeForHospital"
                      type="text"
                      onChange={this.handleChange('form.ifOtherPleaseDescribeForHospital')}
                      value={ifOtherPleaseDescribeForHospital}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.otherDescription' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
          </div>
        }
        <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="nameOfPhysicianFacilityFirstContactedForPhysician"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={nameOfPhysicianFacilityFirstContactedForPhysician}
                  fieldName={messages.treatingPhysicianFacilityFirstContacted}                  
                  >
                    <Textbox
                      name="nameOfPhysicianFacilityFirstContactedForPhysician"
                      type="text"
                      onChange={this.handleChange('form.nameOfPhysicianFacilityFirstContactedForPhysician')}
                      value={nameOfPhysicianFacilityFirstContactedForPhysician}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.treatingPhysicianFacilityFirstContacted' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
        </div>
        <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressForPhysician"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressForPhysician}
                  fieldName={messages.address}                  
                  >
                    <Textbox
                      name="addressForPhysician"
                      type="text"
                      onChange={this.handleChange('form.addressForPhysician')}
                      value={addressForPhysician}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.address' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityOrTownForPhysician"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityOrTownForPhysician}
                  fieldName={messages.cityOrTown}                  
                  >
                    <Textbox
                      name="cityOrTownForPhysician"
                      type="text"
                      onChange={this.handleChange('form.cityOrTownForPhysician')}
                      value={cityOrTownForPhysician}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.cityOrTown' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="countryForPhysician"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={countryForPhysician}
                  fieldName={messages.country}                  
                  >
                    <Textbox
                      name="countryForPhysician"
                      type="text"
                      onChange={this.handleChange('form.countryForPhysician')}
                      value={countryForPhysician}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.country' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalCodeForPhysician"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalCodeForPhysician}
                  fieldName={messages.postalCode}                  
                  >
                    <Textbox
                      name="postalCodeForPhysician"
                      type="text"
                      onChange={this.handleChange('form.postalCodeForPhysician')}
                      value={postalCodeForPhysician}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.postalCode' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
        </div>
        <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberForPhysician"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberForPhysician}
                  fieldName={messages.phoneNumberForPhysician}                  
                  >
                    <Textbox
                      name="phoneNumberForPhysician"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberForPhysician')}
                      value={phoneNumberForPhysician}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.phoneNumberForPhysician' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
                <div className={'col-sm-8 form-group'}></div>
              </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.ifPriorTreatmentWasGivenIn} />
            </PageSectionHeader>      
          </div>         
        </div>
        <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.facilityName} />
                </PageSectionHeader>
                <Textbox
                  name="facilityName"
                  type="text"
                  onChange={this.handleChange('form.facilityName')}
                  value={facilityName}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}></div>
        </div>
        <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.address} />
                </PageSectionHeader>
                <Textbox
                  name="addressForProvide"
                  type="text"
                  onChange={this.handleChange('form.addressForProvide')}
                  value={addressForProvide}
                  disabled={isReadOnly}
                />
              </div>
        </div>
        <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cityOrTown} />
                </PageSectionHeader>
                <Textbox
                  name="cityOrTownForProvide"
                  type="text"
                  onChange={this.handleChange('form.cityOrTownForProvide')}
                  value={cityOrTownForProvide}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.country} />
                </PageSectionHeader>
                <Textbox
                  name="countryForProvide"
                  type="text"
                  onChange={this.handleChange('form.countryForProvide')}
                  value={countryForProvide}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.postalCode} />
                </PageSectionHeader>
                <Textbox
                  name="postalCodeForProvide"
                  type="text"
                  onChange={this.handleChange('form.postalCodeForProvide')}
                  value={postalCodeForProvide}
                  disabled={isReadOnly}
                />
              </div>
        </div>
        <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.phoneNumber} />
                </PageSectionHeader>
                <Textbox
                  name="phoneNumberForProvide"
                  type="number"
                  onChange={this.handleChangePhoneNumber('form.phoneNumberForProvide')}
                  value={phoneNumberForProvide}
                  disabled={isReadOnly}
                />
                <div className={'col-sm-8 form-group'}></div>
              </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-4 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.admitDate} />
              </PageSectionHeader>
              <DatePicker
                disabled={isReadOnly}
                type="text"
                onDayChange={this.handleDayChange('form.admitDate')}
                value={admitDate}
                placeholder="dd/mm/yyyy"
              />
          </div>
          <div className={'col-sm-4 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.timeOfAdmission} />
              </PageSectionHeader>
              <TimePickerInput
                allowEmpty
                showSecond={false}
                onChange={this.onChange('form.timeOfAdmission')}
                value={newTimeOfAdmission}
                placeholder="hh:mm"
                disabled={isReadOnly}
              />
          </div>
          <div className={'col-sm-4 form-group'}></div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-4 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.dischargeDate} />
              </PageSectionHeader>
              <DatePicker
                disabled={isReadOnly}
                type="text"
                onDayChange={this.handleDayChange('form.dischargeDate')}
                value={dischargeDate}
                placeholder="dd/mm/yyyy"
              />
          </div>
          <div className={'col-sm-4 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.timeOfDischarge} />
              </PageSectionHeader>
              <TimePickerInput
                allowEmpty
                showSecond={false}
                onChange={this.onChange('form.timeOfDischarge')}
                value={newTimeOfDischarge}
                placeholder="hh:mm"
                disabled={isReadOnly}
              />
          </div>
          <div className={'col-sm-4 form-group'}></div>   
        </div>       
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness === 'true'}
                    onChange={this.handleChange('form.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness === 'false'}
                    onChange={this.handleChange('form.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.wereYouTravelingToReceiveMedicalTreatment} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wereYouTravelingToReceiveMedicalTreatment === 'true'}
                    onChange={this.handleChange('form.wereYouTravelingToReceiveMedicalTreatment')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wereYouTravelingToReceiveMedicalTreatment === 'false'}
                    onChange={this.handleChange('form.wereYouTravelingToReceiveMedicalTreatment')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>        
        {wereYouTravelingToReceiveMedicalTreatment === 'true' &&
        <div>
          <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="alternativeTreatment"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={alternativeTreatment}
                  fieldName={messages.alternativeTreatment}
                >
                  <Textbox
                    name="alternativeTreatment"
                    type="text"
                    onChange={this.handleChange('form.alternativeTreatment')}
                    value={alternativeTreatment}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.alternativeTreatment' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
          </div>
          <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="ifYesWhenDidYouLearnOfTheAlternativeTreatment"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={ifYesWhenDidYouLearnOfTheAlternativeTreatment}
                  fieldName={messages.ifYesWhenDidYouLearnOfTheAlternativeTreatment}
                >
                  <Textbox
                    name="ifYesWhenDidYouLearnOfTheAlternativeTreatment"
                    type="text"
                    onChange={this.handleChange('form.ifYesWhenDidYouLearnOfTheAlternativeTreatment')}
                    value={ifYesWhenDidYouLearnOfTheAlternativeTreatment}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.ifYesWhenDidYouLearnOfTheAlternativeTreatment' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
          </div>
          <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="whoRecommendedTheTreatment"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={whoRecommendedTheTreatment}
                  fieldName={messages.whoRecommendedTheTreatment}
                >
                  <Textbox
                    name="whoRecommendedTheTreatment"
                    type="text"
                    onChange={this.handleChange('form.whoRecommendedTheTreatment')}
                    value={whoRecommendedTheTreatment}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.whoRecommendedTheTreatment' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
          </div>
        </div>
        }
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.areYouPregnant} />
            </PageSectionHeader>
            <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouPregnant === 'true'}
                    onChange={this.handleChange('form.areYouPregnant')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouPregnant === 'false'}
                    onChange={this.handleChange('form.areYouPregnant')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        {areYouPregnant === 'true' &&
        <div>
          <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="ifYesNumberOfWeeks"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={ifYesNumberOfWeeks}
                  fieldName={messages.ifYesNumberOfWeeks}
                >
                  <Textbox
                    name="ifYesNumberOfWeeks"
                    type="text"
                    onChange={this.handleChange('form.ifYesNumberOfWeeks')}
                    value={ifYesNumberOfWeeks}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.ifYesNumberOfWeeks' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
          </div>
        </div>
        }
      </div>
    );
  }

  renderPrescriptionMedicines() {
    const {
      changeTo,
      ifYesNameOfPhysicianCurrentlyTreatingThis,  
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isRenderAreYouClaimingForUnexpectedRecurrence = !!stepMedicalExpensesExpenseLookup.areYouClaimingForUnexpectedRecurrence.claimCode;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        {this.renderPrescriptionMedicinesForInjury()}
        {this.renderPrescriptionMedicinesNotInjury()}
        {isRenderAreYouClaimingForUnexpectedRecurrence &&
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.changeTo} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={changeTo === 'true'}
                    onChange={this.handleChange('form.changeTo')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={changeTo === 'false'}
                    onChange={this.handleChange('form.changeTo')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
        </div>
        }
        {isRenderAreYouClaimingForUnexpectedRecurrence && changeTo === 'true' &&
        <div className={'ml-2 row'}>
            <div className={'col-sm-6 form-group'}>
                <Validate
                  name="ifYesNameOfPhysicianCurrentlyTreatingThis"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={ifYesNameOfPhysicianCurrentlyTreatingThis}
                  fieldName={messages.ifYesNameOfPhysicianCurrentlyTreatingThis}
                >
                  <Textbox
                    name="ifYesNameOfPhysicianCurrentlyTreatingThis"
                    type="text"
                    onChange={this.handleChange('form.ifYesNameOfPhysicianCurrentlyTreatingThis')}
                    value={ifYesNameOfPhysicianCurrentlyTreatingThis}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.ifYesNameOfPhysicianCurrentlyTreatingThis' }) }}
                    />
                  </ErrorMessage>
                </Validate>
            </div>
            <div className={'col-sm-6 form-group'}>
            </div>     
        </div>}
      </div>
    );
  }

  render() {
    const {
      relationshipToYou,
      nationalIdOrVisa,
      id,
      purposeOfTrip,
      ifOtherPleaseDescribe,
      didYouContactAssistanceCompany,
      assistanceCaseReferenceNumberFileNumber,
      didYouHaveOtherMedicalInsurance,
      insuranceCarriersName,
      address,
      cityOrTown,
      country,
      postalCode,
      policyId,
      areYouACitizenOfTheEuropeanUnion,
      forEUCitizens,
      ifYesWasTheEHIC,
      ifNoPleaseExplain,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div className={'row'}>
          <div className={'col-sm-6 form-group'}>
              <Validate
                name="relationshipToYou"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={relationshipToYou}
                fieldName={messages.relationshipToYou}                  
                >
                  <Textbox
                    name="relationshipToYou"
                    type="text"
                    onChange={this.handleChange('form.relationshipToYou')}
                    value={relationshipToYou}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.relationshipToYou' }) }}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
          <div className={'col-sm-6 form-group'}>
          </div>      
        </div>
        <div className={'row'}>
            <div className={'col-sm-4 form-group'}>
              <Validate
                name="nationalIdOrVisa"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={nationalIdOrVisa}
                fieldName={messages.nationalIdOrVisa}                  
                >
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="true"
                        checked={nationalIdOrVisa === 'true'}
                        onChange={this.handleChange('form.nationalIdOrVisa')}
                      />
                      <FormattedMessage {...messages.nationalId} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="false"
                        checked={nationalIdOrVisa === 'false'}
                        onChange={this.handleChange('form.nationalIdOrVisa')}
                        // onClick={this.props.onResetFormTravelInterruption}
                      />
                    <FormattedMessage {...messages.visa} />
                    </OptionsContainer>
                  </FlexBox>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.nationalIdOrVisa' }) }}
                    />
                  </ErrorMessage>
                </Validate>
            </div>
            <div className={'col-sm-2 form-group'}>
              <Validate
                name="id"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={id}
                fieldName={messages.id}                  
                >
                  <Textbox
                    name="id"
                    type="text"
                    onChange={this.handleChange('form.id')}
                    value={id}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.id' }) }}
                    />
                  </ErrorMessage>
                </Validate>
            </div>
            <div className={'col-sm-6 form-group'}>
            </div> 
        </div>
        <div className="row">
          <div className="form-group col-sm-6">
              <Validate
                name="nationalIdOrVisa"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={purposeOfTrip}
                fieldName={messages.purposeOfTrip}                  
                >
                  <FlexBox justifyContent="space-between">
                    <FlexBox direction="column">
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={purposeOfTrip === 'Holiday'}
                        onChange={this.handleChange('form.purposeOfTrip')}
                        value="Holiday"
                      />
                      <FormattedMessage {...messages.holiday} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={purposeOfTrip === 'Business'}
                        onChange={this.handleChange('form.purposeOfTrip')}
                        value="Business"
                      />
                      <FormattedMessage {...messages.business} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={purposeOfTrip === 'Medical'}
                        onChange={this.handleChange('form.purposeOfTrip')}
                        value="Medical"
                      />
                      <FormattedMessage {...messages.medical} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={purposeOfTrip === 'Other'}
                        onChange={this.handleChange('form.purposeOfTrip')}
                        value="Other"
                      />
                      <FormattedMessage {...messages.other} />
                    </OptionsContainer>
                    </FlexBox>
                  </FlexBox>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.purposeOfTrip' }) }}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
          <div className={'col-sm-6 form-group'}>
          </div>
        </div>
        {purposeOfTrip === 'Other' &&
        <div className={'row'}>
          <div className={'form-group col-sm-11'}>
            <Validate
              name="ifOtherPleaseDescribe"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={ifOtherPleaseDescribe}
              fieldName={messages.ifOtherPleaseDescribe}
            >
              <TextArea
                disabled={isReadOnly}
                name="ifOtherPleaseDescribe"
                type="text"
                onChange={this.handleChange('form.ifOtherPleaseDescribe')}
                value={ifOtherPleaseDescribe}
                isSummary={isSummary}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.ifOtherPleaseDescribe' }) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-sm-1 form-group'}></div>
        </div>}
        {purposeOfTrip !== 'Other' &&
        <div className={'row'}>
          <div className={'form-group col-sm-11'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.ifOtherPleaseDescribe} />
            </PageSectionHeader>
            <TextArea
              disabled={isReadOnly}
              name="ifOtherPleaseDescribe"
              type="text"
              onChange={this.handleChange('form.ifOtherPleaseDescribe')}
              value={ifOtherPleaseDescribe}
              isSummary={isSummary}
            />
          </div>
          <div className={'col-sm-1 form-group'}></div>
        </div>}
        <div className={'row'}>
          <div className={'col-sm-5 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didYouContactAssistanceCompany} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYouContactAssistanceCompany === 'true'}
                    onChange={this.handleChange('form.didYouContactAssistanceCompany')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYouContactAssistanceCompany === 'false'}
                    onChange={this.handleChange('form.didYouContactAssistanceCompany')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
          {didYouContactAssistanceCompany === 'true' &&
          <div className={'col-sm-6 form-group'}>
                <Validate
                  name="thirdPartySurName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={assistanceCaseReferenceNumberFileNumber}
                  fieldName={messages.assistanceCaseReferenceNumberFileNumber}
                >
                <Textbox
                  name="assistanceCaseReferenceNumberFileNumber"
                  type="text"
                  onChange={this.handleChange('form.assistanceCaseReferenceNumberFileNumber')}
                  value={assistanceCaseReferenceNumberFileNumber}
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.assistanceCaseReferenceNumberFileNumber' }) }}
                  />
                </ErrorMessage>
              </Validate>
          </div>}
          <div className={'col-sm-1 form-group'}></div> 
        </div>
        <div className={'row'}>
          <div className={'col-sm-5 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.didYouHaveOtherMedicalInsurance} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYouHaveOtherMedicalInsurance === 'true'}
                    onChange={this.handleChange('form.didYouHaveOtherMedicalInsurance')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYouHaveOtherMedicalInsurance === 'false'}
                    onChange={this.handleChange('form.didYouHaveOtherMedicalInsurance')}
                    // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
          <div className={'col-sm-7 form-group'}></div>
        </div>
        {didYouHaveOtherMedicalInsurance === 'true' &&
          <div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.ifYesPleaseProvide} />
                </PageSectionHeader>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="insuranceCarriersName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={insuranceCarriersName}
                  fieldName={messages.insuranceCarriersName}
                >
                  <Textbox
                    name="insuranceCarriersName"
                    type="text"
                    onChange={this.handleChange('form.insuranceCarriersName')}
                    value={insuranceCarriersName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.insuranceCarriersName' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="address"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={address}
                  fieldName={messages.address}
                >
                  <Textbox
                    name="address"
                    type="text"
                    onChange={this.handleChange('form.address')}
                    value={address}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.address' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityOrTown"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityOrTown}
                  fieldName={messages.cityOrTown}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.cityOrTown')}
                    value={cityOrTown}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.cityOrTown' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.country')}
                    value={country}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.country' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalCode"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalCode}
                  fieldName={messages.postalCode}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.postalCode')}
                    value={postalCode}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.postalCode' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="policyId"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={policyId}
                  fieldName={messages.policyId}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.policyId')}
                    value={policyId}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.policyId' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>        
          </div>}
          <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.areYouACitizenOfTheEuropeanUnion} />
                  </PageSectionHeader>
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="true"
                        checked={areYouACitizenOfTheEuropeanUnion === 'true'}
                        onChange={this.handleChange('form.areYouACitizenOfTheEuropeanUnion')}
                      />
                      <FormattedMessage {...messages.yes} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="false"
                        checked={areYouACitizenOfTheEuropeanUnion === 'false'}
                        onChange={this.handleChange('form.areYouACitizenOfTheEuropeanUnion')}
                        onClick={this.props.onResetFormEuropeanUnionData}
                      />
                      <FormattedMessage {...messages.no} />
                    </OptionsContainer>
                  </FlexBox>
              </div>
          </div>
          {areYouACitizenOfTheEuropeanUnion === 'true' &&
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.forEUCitizens} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={forEUCitizens === 'true'}
                      onChange={this.handleChange('form.forEUCitizens')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={forEUCitizens === 'false'}
                      onChange={this.handleChange('form.forEUCitizens')}
                      // onClick={this.props.onResetFormTravelInterruption}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
            </div>
          </div>}
          {areYouACitizenOfTheEuropeanUnion === 'true' && forEUCitizens === 'true' &&
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.ifYesWasTheEHIC} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={ifYesWasTheEHIC === 'true'}
                      onChange={this.handleChange('form.ifYesWasTheEHIC')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={ifYesWasTheEHIC === 'false'}
                      onChange={this.handleChange('form.ifYesWasTheEHIC')}
                      // onClick={this.props.onResetFormTravelInterruption}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
            </div>
          </div>}        
          {ifYesWasTheEHIC === 'false' && forEUCitizens === 'true' &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
                <Validate
                  name="ifNoPleaseExplain"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={policyId}
                  fieldName={messages.ifNoPleaseExplain}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.ifNoPleaseExplain')}
                    value={ifNoPleaseExplain}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.ifNoPleaseExplain' }) }}
                    />
                  </ErrorMessage>
                </Validate>
            </div>
            <div className={'col-sm-6 form-group'}>
            </div>
          </div>}
        {this.renderHospitalAndMedicalExpenses()}
        {this.renderPrescriptionMedicines()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepMedicalExpenses.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  onResetFormData: PropTypes.func,
  onResetFormEuropeanUnionData: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepMedicalExpenses(),
  errors: makeSelectStepMedicalExpensesErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  onResetFormEuropeanUnionData: () => dispatch(resetFormEuropeanUnionData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepMedicalExpenses', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(StepMedicalExpenses);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepMedicalExpenses/index.js